import React from "react";
import { Modal } from "react-bootstrap"; 
import { calculateTotalPrice } from "./foodItemLogic";
import { getAddonQuantity, getOptionQuantity, getOptionPrice, getSubOptionQuantity, getSubOptionPrice } from "./addonLogic"; // ggg: Added imports for getSubOptionQuantity and getSubOptionPrice
import "./FoodItem.css"; 

// Updated BreakdownModal to reuse getSubOptionQuantity and getSubOptionPrice
export default function BreakdownModal({
  show,
  onHide,
  addon,
  selectedAddon,
  foodItemQuantity,
}) {
  // debugger
  // Calculate addon quantity using getAddonQuantity
  
  const addonQty = getAddonQuantity({
    addon,
    selectedAddon,
    foodItemQuantity,
    isChecked: selectedAddon?.enabled,
    isLinked: addon.isCountable && addon.isCountableLinked,
  });

  // Create a mock food object with only the current addon
  const Food = {
    itemBasePrice: 0, // Set to 0 since we only want addon price
    addOns: [addon], // Include only the specific addon
  };

  // Create a mock selectedAddons object with only the current addon
  const SelectedAddons = {
    [addon.id]: selectedAddon,
  };

  // Calculate total price for the addon using calculateTotalPrice
  const totalPrice = calculateTotalPrice(Food, foodItemQuantity, SelectedAddons);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{addon.addOnName} Breakdown</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="breakdown-modal">
          {addonQty > 0 ? (
            <div className="mb-3">
              <h6>
                {addon.addOnName} (x{addonQty}) - £{(addon.basePrice * addonQty).toFixed(2)}
              </h6>
              {selectedAddon?.options && (
                <ul>
                  {Object.entries(selectedAddon.options).map(([optionId, optionSel]) => {
                    if (!optionSel.enabled) return null;
                    const optionDef = addon.options.find((o) => o.optionId === optionId);
                    if (!optionDef) return null;

                    const optionQty = getOptionQuantity({
                      addon,
                      selectedAddon,
                      optionDef,
                      optionSel,
                      foodItemQuantity,
                    });
                    const optionPrice = getOptionPrice({ optionDef, optionQty });

                    return (
                      <li key={optionId}>
                        <strong>{optionDef.optionName} (x{optionQty})</strong> - £{optionPrice.toFixed(2)}
                        {optionSel.subOptions && (
                          <ul>
                            {Object.entries(optionSel.subOptions).map(([subOptionId, subOptionSel]) => {
                              if (!subOptionSel.enabled) return null;
                              const subOptionDef = optionDef.subOptions.find(
                                (so) => so.subOptionId === subOptionId
                              );
                              if (!subOptionDef) return null;
                              // Use utility functions for subOptionQty and subOptionPrice
                              const subOptionQty = getSubOptionQuantity({ optionQty });
                              const subOptionPrice = getSubOptionPrice({ subOptionDef, subOptionQty });

                              return (
                                <li key={subOptionId}>
                                  {subOptionDef.subOptionName} (x{subOptionQty}) - £{subOptionPrice.toFixed(2)}
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          ) : (
            <p>No selections made for this addon.</p>
          )}
          <hr />
          <h5>Total Price: £{totalPrice.toFixed(2)}</h5>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}